import CallbackArgs, { defaultCallbackArgs } from '../messages/callback-args'
import MessageArgs from '../messages/message-args'
import fullscreenDialogManager from '../fullscreen/fullscreen-dialog-manager'
import sendMessageToSidebar from '../messages/send-message-to-sidebar'

interface SetViewRequestArgs extends MessageArgs {
  view: 'sidebar' | 'fullscreen'
  path?: string
}

interface SetViewRequestCallbackArgs extends CallbackArgs {
  view: 'sidebar' | 'fullscreen'
  success: boolean
  presentation?: 'inline' | 'window'
}

// The portal asks for a view change when navigating on/off routes flagged
// meta.fullscreenView (PENG-803). Outlook cannot widen the taskpane, so 'fullscreen'
// opens the wide view in an Office Dialog; unsupported hosts (mobile, DialogApi < 1.2)
// reply success:false and the portal stays on the narrow layout.
export default async function setViewRequestHandler(data: SetViewRequestArgs) {
  const callbackArgs = defaultCallbackArgs() as SetViewRequestCallbackArgs
  callbackArgs.view = data.view

  try {
    if (data.view === 'sidebar') {
      fullscreenDialogManager.close()
      callbackArgs.success = true
    } else if (!fullscreenDialogManager.isSupported()) {
      callbackArgs.success = false
    } else {
      callbackArgs.success = await fullscreenDialogManager.open(data.path)
      if (callbackArgs.success) {
        callbackArgs.presentation = 'window'
      }
    }
  } catch {
    callbackArgs.success = false
  } finally {
    sendMessageToSidebar('SetViewRequestCallback', callbackArgs)
  }
}
